import { useCms } from '~/components/hooks/useCms';
import { isOrganizationAuOrg } from '~/Utils';

export function useVatLabel(): string {
  const { userOrganization } = useCms();
  return isOrganizationAuOrg(userOrganization) ? 'GST' : 'VAT';
}
